interface ColorPreviewProps {
  color?: string
  dataCy?: string
}

const DEFAULT_COLOR = 'white'

export const ColorPreview = ({color, dataCy}: ColorPreviewProps) => (
  <div className="h-8 w-8 border-1px rounded-[4px]" style={{background: color ?? DEFAULT_COLOR}} data-cy={dataCy} />
)
